import PropTypes from 'prop-types';

const ListBoxOptionPropType = PropTypes.shape({
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
});
const ListBoxGroupPropType = PropTypes.shape({
  group: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(ListBoxOptionPropType).isRequired
});

export { ListBoxGroupPropType, ListBoxOptionPropType };
